import { useState, MouseEvent } from 'react';
import MakeModelHeader from 'components/Shared/MakeModelMenu/MakeModelHeader';
import ModelListResults from 'components/Shared/MakeModelMenu/ListResults';
import { useTranslation } from 'react-i18next';
import Model from 'types/Model';
import Make from 'types/Make';

function filterModels(models: Model[], filter?: string): Model[] {
  if (!filter) {
    return models;
  }

  return models.filter((model) => model.name.toLowerCase().includes(filter.toLowerCase()));
}

interface ModelsListProps {
  make: Make;
  models: Model[];
  choose: (value: Model) => void;
  allModelsOption?: boolean;
  className?: string;
  showMakes: (event: MouseEvent) => void;
  filterIndex?: number;
}

export default function ModelsList({
  make,
  models,
  choose,
  allModelsOption = true,
  className,
  showMakes,
  filterIndex,
}: ModelsListProps): JSX.Element {
  const [filter, setFilter] = useState<string>();
  const { t } = useTranslation();

  return (
    <div data-models-list className={className}>
      <ul className="make-model-menu-models-list">
        <MakeModelHeader
          handleFilter={setFilter}
          includeAll={allModelsOption}
          allText={t('makeModelSearch.allModels', { make: make.name })}
          chooseAll={choose}
          makeOrModel={'model'}
          showMakes={showMakes}
          make={make.name}
          filterIndex={filterIndex}
        />
        <ModelListResults models={filterModels(models, filter)} choose={choose} />
      </ul>
      <style jsx>{`
        .make-model-menu-models-list {
          margin: 0;
          padding: 0;
        }
      `}</style>
    </div>
  );
}
